import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'

export const initializeNewsTeaser = () => {
  const sliders = document.querySelectorAll('[data-component="news-teaser-slider"]')

  sliders.forEach(slider => {
    const swiperElement = slider.querySelector('.swiper')
    if (!swiperElement) return

    // Swiper sizes slides from offsetWidth, which always rounds to a whole
    // pixel. If the frame itself renders at a fractional width (common in
    // fluid layouts), the frame ends up a hair wider than the slide,
    // exposing a sliver of the next slide through the clipped edge. Pinning
    // the frame to the floor of its fluid width keeps both in sync.
    const syncFrameWidth = () => {
      swiperElement.style.width = Math.floor(slider.getBoundingClientRect().width) + 'px'
    }
    syncFrameWidth()

    const swiperInstance = new Swiper(swiperElement, {
      slidesPerView: 1,
      speed: 400,
      simulateTouch: true,
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      }
    })

    window.addEventListener('resize', () => {
      syncFrameWidth()
      swiperInstance.update()
    })

    // Cursor and Click Navigation across the whole card
    slider.addEventListener('mousemove', (e) => {
      if (e.target.closest('a, button, .swiper-pagination')) {
        slider.style.cursor = 'auto'
        slider.dataset.cursorDirection = ''
        return
      }

      const rect = slider.getBoundingClientRect()
      const x = e.clientX - rect.left

      if (x < rect.width / 2) {
        slider.style.cursor = 'var(--cursor-prev)'
        slider.dataset.cursorDirection = 'prev'
      } else {
        slider.style.cursor = 'var(--cursor-next)'
        slider.dataset.cursorDirection = 'next'
      }
    })

    slider.addEventListener('click', (e) => {
      if (e.target.closest('a, button, .swiper-pagination')) return

      if (slider.dataset.cursorDirection === 'prev') {
        swiperInstance.slidePrev()
      } else {
        swiperInstance.slideNext()
      }
    })
  })
}
